import { useTheme } from "@emotion/react";
import Box from "@mui/material/Box";
import { styled } from '@mui/material/styles';
import { useContext, useState } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.scss";
import MenuLeft from "./app/menu.left";
import MenuRight from "./app/menu.right";
import MenuTop from "./app/menu.top";
import ForbiddenView from "./auth/forbidden.view";
import LoginView from "./auth/login.view";
import CatchupView from "./calendar/catchup/catchup.view";
import DailyView from "./calendar/daily/daily.view";
import MonthlyView from "./calendar/monthly/monthly.view";
import ThreeDayView from "./calendar/threeDay/threeDay.view";
import UpcomingView from "./calendar/upcoming/upcoming.view";
import WeeklyView from "./calendar/weekly/weekly.view";
import { DrawerSibling } from "./common/drawer";
import SnackbarHandler from "./common/snackbar.handler";
import { SessionDataContext } from "./contexts";
import CourseList from "./course/course.list";
import CourseView from "./course/course.view";
import HolidayList from "./holiday/holiday.list";
import ReportCardView from "./reportCard/reportCard.view";
import SchoolView from "./school/school.view";
import StudentList from "./student/student.list";
import StudentView from "./student/student.view";
import TermList from "./term/term.list";
import TermView from "./term/term.view";
import TodoList from "./todo/todo.list";
import UserView from "./user/user.view";
import UserWizardView from "./user/user.wizard";
import TermPlanner from "./term/term.planner";
import RequirePermission from "./auth/require.permission";
import CanAny from "./auth/can.any";

export const Offset = styled(Box)(({ theme }) => theme.mixins.toolbar);

export default function App() {
	const [openLeft, setOpenLeft] = useState(false);
	const theme = useTheme();
	const sessionData = useContext(SessionDataContext);
	const open = sessionData.drawerOpen;

	return (
		<Box sx={{ flexGrow: 1 }}>
			<MenuTop open={openLeft} setOpen={setOpenLeft} />
			<Offset />

			<SnackbarHandler />

			<CanAny permissions={['user.view','student.list','course.list','term.list','holiday.list','catchup.view','upcoming.view','daily.view','threeDay.view','weekly.view','monthly.view']}>
				<MenuLeft open={openLeft} setOpen={setOpenLeft} />
			</CanAny>
			<MenuRight />

			<DrawerSibling open={open}>
				<Routes>
					<Route path="/login" element={<LoginView />} />
					<Route path="/" element={<UserView />} />
					<Route path="/profile" element={<UserView />} />
					<Route path="/wizard" element={
						<RequirePermission permission="user.wizard.view">
							<UserWizardView />
						</RequirePermission>
					} />
					<Route path="/school" element={
						<RequirePermission permission="school.view">
							<SchoolView />
						</RequirePermission>
					} />
					<Route path="/todos" element={
						<RequirePermission permission="todo.list">
							<TodoList />
						</RequirePermission>
					} />
					<Route path="/students" element={
						<RequirePermission permission="student.list">
							<StudentList />
						</RequirePermission>
					} />
					<Route path="/students/:id" element={
						<RequirePermission permission="student.view">
							<StudentView />
						</RequirePermission>
					} />
					<Route path="/courses" element={
						<RequirePermission permission="course.list">
							<CourseList />
						</RequirePermission>} />
					<Route path="/courses/:id" element={
						<RequirePermission permission="course.view">
							<CourseView />
						</RequirePermission>
					} />
					<Route path="/courses/:id/:navTab" element={
						<RequirePermission permission="course.view">
							<CourseView />
						</RequirePermission>
					} />
					<Route path="/courses/:id/enrollments/:enrollmentId" element={
						<RequirePermission permission="course.view">
							<CourseView />
						</RequirePermission>
					} />
					<Route path="/terms" element={
						<RequirePermission permission="term.list">
							<TermList />
						</RequirePermission>
					} />
					<Route path="/terms/:id" element={
						<RequirePermission permission="term.view">
							<TermView />
						</RequirePermission>
					} />
					<Route path="/terms/:termId/students/:studentId" element={
						<RequirePermission permission="term.planner">
							<TermPlanner />
						</RequirePermission>
					} />
					<Route path="/terms/:termId/students/:studentId/reportCard" element={
						<RequirePermission permission="reportCard.view">
							<ReportCardView />
						</RequirePermission>
					} />
					<Route path="/holidays" element={
						<RequirePermission permission="holiday.list">
							<HolidayList />
						</RequirePermission>
					} />
					<Route path="/catchup" element={
						<RequirePermission permission="catchup.view">
							<CatchupView />
						</RequirePermission>
					} />
					<Route path="/upcoming" element={
						<RequirePermission permission="upcoming.view">
							<UpcomingView />
						</RequirePermission>
					} />
					<Route path="/calendar/daily" element={
						<RequirePermission permission="daily.view">
							<DailyView />
						</RequirePermission>
					} />
					<Route path="/calendar/3-day" element={
						<RequirePermission permission="threeDay.view">
							<ThreeDayView />
						</RequirePermission>
					} />
					<Route path="/calendar/weekly" element={
						<RequirePermission permission="weekly.view">
							<WeeklyView />
						</RequirePermission>
					} />
					<Route path="/calendar/monthly" element={
						<RequirePermission permission="monthly.view">
							<MonthlyView />
						</RequirePermission>
					} />

					<Route path="/forbidden" element={<ForbiddenView />} />
				</Routes>
			</DrawerSibling>
		</Box>
	);
}